import AService from '@/services/AService'

const ENTITY_NAME = 'requests';

export default class RequestService extends AService {
  /**
   * Creation d'une demande de rendez vous
   * @param {RequestCreateRequest} request la requête de demande de rendez vous
   * @return {Promise<*>}
   */
  async createRequest(request){
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}`, request);
    return response.data
  }

  /**
   *
   * @param {number} id
   * @return {Promise<*>}
   */
  async validateRequest(id){
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/validate/${id}`);
    return response.data
  }

  /**
   * Requête permettant de supprimer une demande
   * @param {number} id
   * @return {Promise<*>}
   */
  async deleteRequest(id){
    const response = await this.http.delete(`${this.baseUrl}/${ENTITY_NAME}/delete/${id}`);
    return response.data
  }
}
